"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const common_types_1 = require("@le2/common-types");
const jfd_1 = require("@le2/jfd");
const e2e_cypress_config_kcso_1 = __importDefault(require("./e2e-cypress-config-kcso"));
const jfd_kcso_1 = require("./jfd-kcso");
const jfd_smt_kcso_1 = require("./jfd-smt-kcso");
const jfl_kcso_1 = require("./jfl-kcso");
const partialConfig = {
    jfd: jfd_kcso_1.jfd,
    bookingJFL: jfl_kcso_1.bookingJFL,
    features: {
        agencyName: 'kcso',
        bookings: {
            onlyMandatoryCheckbox: false,
            smt: {
                strategy: 'type10',
                jfd: jfd_smt_kcso_1.jfdSmt,
                jfl: jfd_1.jflSmt
            },
            table: {
                columns: [
                    { name: 'DisplayFullName', styles: { width: '300px' } },
                    { name: 'DateOfBirth', styles: { width: '145px' } },
                    { name: 'Sex', styles: { width: '145px' } },
                    { name: 'Race', styles: { width: '170px' } }
                ],
                sort: [jfd_kcso_1.bookingNumberFieldName, 'DateOfBirth', 'Sex', 'Race', 'createdAt_pgcolumn'],
                multipleSelection: true
            },
            search: {
                simple: [jfd_kcso_1.bookingNumberFieldName, 'SubjectName.First', 'SubjectName.Last'],
                advanced: [
                    'SubjectName.First',
                    'SubjectName.Last',
                    'DateOfBirth',
                    {
                        index: 'AgeRange',
                        field: 'DateOfBirth',
                        isRange: true,
                        label: 'Age',
                        type: 'ageRange',
                        minLength: 2,
                        maxLength: 2
                    },
                    { field: 'Date', isRange: true },
                    { field: 'DateOfArrest', isRange: true },
                    'UCN',
                    'BookingAgency',
                    'Sex',
                    'Race',
                    'EyeColor',
                    'HairColor',
                    { field: 'Height', isRange: true, type: 'number' },
                    { field: 'Weight', isRange: true, type: 'number' },
                    'MugshotPhysicalCharacteristicsSet.HairLength',
                    'MugshotPhysicalCharacteristicsSet.FacialHair',
                    'MugshotPhysicalCharacteristicsSet.Beard',
                    'MugshotPhysicalCharacteristicsSet.Mustache',
                    'MugshotPhysicalCharacteristicsSet.Sideburns',
                    'MugshotPhysicalCharacteristicsSet.Complexion',
                    'MugshotPhysicalCharacteristicsSet.Build',
                    'ResidenceOfPersonFingerprinted',
                    'Aliases',
                    'SMT'
                ]
            },
            printFields: [
                'ResidenceOfPersonFingerprinted',
                'Aliases',
                'Sex',
                'Race',
                'HairColor',
                'EyeColor',
                'DateOfBirth',
                'CurrentAge',
                'Height',
                'Weight',
                'MugshotPhysicalCharacteristicsSet.Glasses',
                'MugshotPhysicalCharacteristicsSet.HairLength',
                'MugshotPhysicalCharacteristicsSet.HairStyle',
                'MugshotPhysicalCharacteristicsSet.Complexion',
                'MugshotPhysicalCharacteristicsSet.Beard',
                'MugshotPhysicalCharacteristicsSet.Mustache',
                'MugshotPhysicalCharacteristicsSet.Sideburns',
                'MugshotPhysicalCharacteristicsSet.FacialHair',
                'MugshotPhysicalCharacteristicsSet.Build',
                'SkinTone',
                'DateOfArrest',
                'LocalAFISNumber',
                'UCN',
                { field: 'FBINumber', full: false, summary: true },
                { field: 'StateIDNumber', full: false, summary: true },
                { field: 'SocialSecurityNumber', full: false, summary: true }
            ],
            import: {
                whitelist: [
                    // Any field in the incoming EBTS file not on this list will simply get ignored on import
                    'TypeOfTransaction',
                    jfd_kcso_1.bookingNumberFieldName,
                    'BookingAgency',
                    'LegacyJailIdentifier',
                    'UCN',
                    'Date',
                    'TransactionControlNumber',
                    'FullName',
                    'DisplayFullName',
                    'SubjectName',
                    'Aliases',
                    'PlaceOfBirth',
                    'DateOfBirth',
                    'Sex',
                    'Race',
                    'Height',
                    'Weight',
                    'EyeColor',
                    'HairColor',
                    'ResidenceOfPersonFingerprinted',
                    'DateOfArrest',
                    'LocalAFISNumber',
                    'MugshotPhysicalCharacteristicsSet',
                    'FBINumber',
                    'StateIDNumber',
                    'SocialSecurityNumber',
                    'BookingAge'
                ],
                // Any field in the incoming EBTS file not on this list will cause an import exception and abort the operation
                redlist: [jfd_kcso_1.bookingNumberFieldName]
            }
        },
        lineups: {
            filters: [
                'Sex',
                'Race',
                'EyeColor',
                'HairColor',
                'MugshotPhysicalCharacteristicsSet.HairLength',
                'MugshotPhysicalCharacteristicsSet.HairStyle',
                'MugshotPhysicalCharacteristicsSet.FacialHair',
                'MugshotPhysicalCharacteristicsSet.Complexion',
                'MugshotPhysicalCharacteristicsSet.Beard',
                'MugshotPhysicalCharacteristicsSet.Mustache',
                'MugshotPhysicalCharacteristicsSet.Sideburns',
                'MugshotPhysicalCharacteristicsSet.Glasses',
                'MugshotPhysicalCharacteristicsSet.Build',
                {
                    field: 'BookingAge',
                    label: 'Age Range at Booking',
                    isRange: true,
                    type: 'number',
                    minValue: 18,
                    maxValue: 100,
                    errorMsg: 'You must enter a data range such as 18-100'
                }
            ],
            table: {
                columns: ['Sex', 'Race']
            },
            lineupSizes: [6, 12],
            sealedSearch: false,
            typeOptions: {
                face: true,
                smt: false
            }
        },
        audits: {
            subjectNameFormat: '<Last Name>, <First Name> <Middle Name (optional)>'
        },
        oidc: {
            /** OIDC login users related settings */
            users: {
                /**
                 * If OIDC users should be displayed and managed
                 */
                hide: true,
                /**
                 * If OIDC users should be automatically enrolled when they first authenticate to the system
                 */
                autoenroll: true,
                /**
                 * How the id token claims of OIDC users should be mapped to the application's roles
                 */
                idTokenClaimsMapping: {
                    email: ['email', 'emails'],
                    firstName: ['firstName', 'given_name'],
                    lastName: ['lastName', 'family_name'],
                    department: ['Agency'],
                    extId: ['sub'],
                    roles: {
                        // list of claims to map to the defined application groups (DefaultGroups enum - common types)
                        default: common_types_1.DefaultGroups.BookingInvestigative,
                        claimToAccessTypeMap: [
                            { claimName: 'Crimes2Role', claimValue: 'Audit User', accessType: { type: 'Admin' } },
                            { claimName: 'Crimes2Role', claimValue: 'Admin User', accessType: { type: 'Admin' } },
                            { claimName: 'kcAdmin', claimValue: true, accessType: { type: 'Admin' } }
                        ]
                    }
                }
            }
        }
    },
    cypressConfig: e2e_cypress_config_kcso_1.default
};
// // Add the booking number field name after-the-fact because it's dynamic
// if (jfd.bookingNumberFieldName) {
//   const importConfig = config.features.bookings.import
//   importConfig.whitelist = [jfd.bookingNumberFieldName, ...importConfig.whitelist]
// }
const config = jfd_1.createAgencyConfig(partialConfig);
exports.default = config;
//# sourceMappingURL=index.js.map